import styled from "styled-components/macro";
import { cardBorder, darkGrey } from "../../../../constants/colors";
import { FONT_SIZE_EXTRA_SMALL } from "../../../../constants/constants";
import { CSS_TOOLTIP } from "../../RechartHelpers/TooltipStyles";

export const GenericComposedChartStyles = styled.div<{ hideYAxis: boolean }>`
  display: flex;
  flex-direction: column;
  align-content: center;
  justify-content: center;

  .chartTitle {
    font-family: "Open Sans SemiBold";
    text-align: center;
    font-size: 20px;
  }

  &&& {
    .chartBody {
      box-sizing: border-box;
      font-family: "Open Sans";

      /* axis title labels */
      .recharts-yAxis,
      .recharts-xAxis {
        font-size: 16px;
      }

      /* Hide y-axis line */
      .recharts-yAxis {
        .recharts-cartesian-axis-line,
        .recharts-cartesian-axis-tick-line {
          display: ${props => (props.hideYAxis ? "none" : "initial")};
        }
      }

      /* Make x-axis line bolder */
      .recharts-xAxis {
        .recharts-cartesian-axis-line {
          stroke: black;
          font-weight: bold;
        }
      }

      /* axis values */
      .recharts-cartesian-axis-ticks {
        font-size: ${FONT_SIZE_EXTRA_SMALL}px;
        color: ${darkGrey};
      }

      /* cartesian grid */
      .recharts-cartesian-grid {
        color: ${cardBorder};
      }

      /* tooltip styling */
      .recharts-default-tooltip {
        ${CSS_TOOLTIP}
      }
    }
  }
  .print {
    .chartTitle {
      font-size: ${FONT_SIZE_EXTRA_SMALL}px;
    }
  }
`;
